<template>
  <div class="wrapper">
    <div class="page-header header-filter header-xs" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center">
            <h1 class="title">Our Products</h1>
            <h4></h4>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="product-message">
              {{ productMessage }}
            </div>
            <tabs :tabActive="activeTab" :tabName="categories" :onChange="tabChanged">
              <template v-slot:content>
                <div style="display:flex; flex-wrap: wrap;">
                  <div class="md-layout-item md-size-33 md-small-size-100" v-for="product in filteredProducts"
                    :key="product.id">
                    <product-card text-center class="mt-3" card-plain :cardLink="`/product/${product.id}`"
                      :card-image="imageForProduct(product)" :shadow-normal="false" :no-colored-shadow="false">
                      <template slot="cardContent">
                        <a :href="`/product/${product.id}`">
                          <h4 class="card-title">{{ product.name }}</h4>
                        </a>
                        <p class="card-description">
                          {{ product.description }}
                        </p>
                      </template>
                      <template slot="cardAction">
                        <!-- <div class="price-container">
                          <span class="price">
                            ${{ product.price }}/{{ labelForProductUnit(product.units) }}
                          </span>
                        </div> -->
                        <div class="ml-auto" :class="product.status">
                          {{ labelForProductStatus(product.status) }}
                        </div>
                      </template>
                    </product-card>
                  </div>
                </div>
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProductCard, Tabs } from '@/components';
import Mixins from '@/plugins/basicMixins';
import { Query } from '@/graphql';
import apollo from '@/services/apollo-graphql';
import labelForProductStatus from '@/mixins/labelForProductStatus';
import labelForProductUnit from '@/mixins/labelForProductUnit';

export default {
  components: {
    ProductCard,
    Tabs
  },
  mixins: [Mixins.HeaderImage, labelForProductStatus, labelForProductUnit],
  data() {
    return {
      activeTab: 1,
      products: [],
      productMessage: '',
      selectedCategory: 'All',
      categories: ['All'],
      image: require('@/assets/img/products-bg.png'),
    };
  },
  async created() {
    let response = await apollo.query({
      query: Query.getProducts,
    });
    this.products = response.data.products;

    response = await apollo.query({
      query: Query.getProductCategories,
    });
    this.categories.push(...response.data.productCategories);

    response = await apollo.query({
      query: Query.getProductMessage,
    });
    this.productMessage = response.data.productMessage;

    this.updateSelectedCategory(this.$route.hash);
  },
  beforeRouteUpdate(to, from, next) {
    this.updateSelectedCategory(to.hash)
    next();
  },
  computed: {
    filteredProducts() {
      switch (this.selectedCategory) {
        case 'All':
          return this.products;
        default:
          return this.products.filter(p => p.category === this.selectedCategory);
      }
    }
  },
  methods: {
    imageForProduct(product) {
      if (product.photos && product.photos.length) {
        return product.photos[0].url;
      }
      return require('@/assets/img/product-placeholder.png');
    },
    tabChanged(category) {
      this.selectedCategory = category;
      this.$router.push(`/products#${category}`)
    },
    updateSelectedCategory(routeHash) {
      const category = routeHash.replace('#', '')
      const index = this.categories.indexOf(category);
      if (index !== -1) {
        this.selectedCategory = category;
        this.activeTab = index + 1;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.card-description {
  min-height: 24px;
}

.price {
  color: black !important;
}

.product-message {
  color: #FB9718;
  text-align: center;
  font-weight: 400;
  width: 100%;
  font-size: 20px;
  padding: 15px;
  margin-bottom: 30px;
}
</style>
